export default class GeneralResponse {
    requestId: string
    success: boolean
    context: string | null
    data: unknown

    constructor(requestId?: string, success?: boolean, context?: string, data?: unknown) {
        this.requestId = requestId ?? ''
        this.success = success ?? false
        this.context = context ?? null
        this.data = data ?? null
    }
}
